"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reactRedux = require("react-redux");

var _react = _interopRequireWildcard(require("react"));

var _reactSchemaorg = require("react-schemaorg");

var _reactHelmet = require("react-helmet");

var _SpecificDetailsComponent = _interopRequireDefault(require("./SpecificDetailsComponent"));

var _ColorPickerComponent = _interopRequireDefault(require("./ColorPickerComponent"));

var _convertEntities = _interopRequireDefault(require("../../../../../configuration/convertEntities"));

var _utils = require("../../../../../configuration/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var DetailsDescriptionComponent = function DetailsDescriptionComponent() {
  var _pimProduct$images$;

  var pimProduct = (0, _reactRedux.useSelector)(function (state) {
    return state.selectedProduct;
  });
  var isMobile = (0, _reactRedux.useSelector)(function (state) {
    return state.isMobile;
  });
  var dictionary = (0, _reactRedux.useSelector)(function (state) {
    return state.dictionary;
  });

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      productName = _useState2[0],
      setproductName = _useState2[1];

  (0, _react.useEffect)(function () {
    setproductName(pimProduct.title);
  }, [pimProduct]);

  var trackMobileStoreLinks = function trackMobileStoreLinks(e, app) {
    e.preventDefault();

    if (e.currentTarget.href.includes('apple')) {
      (0, _utils.sendGA4DataLayerEvent)('genericGAEvent', 'product_details', 'appstore_click', app.name, app.id, '');
      window.open(app.appStoreLink);
    }

    if (e.currentTarget.href.includes('google')) {
      (0, _utils.sendGA4DataLayerEvent)('genericGAEvent', 'product_details', 'googleplay_click', app.name, app.id, '');
      window.open(app.googlePlayLink);
    }
  };

  var renderProductLinks = function renderProductLinks() {
    // I think we need to have a separate category for apps in PIM, in order to distinguish them from the rest of products
    // this is temporary hardcoded solution for three currently existing ones
    var apps = [{
      name: 'ON',
      id: 316113,
      appStoreLink: dictionary.oticonOnAppStoreLink,
      googlePlayLink: dictionary.oticonOnGooglePlayLink
    }, {
      name: 'RemoteCare',
      id: 316114,
      appStoreLink: dictionary.remoteCareAppStoreLink,
      googlePlayLink: dictionary.remoteCareGooglePlayLink
    }, {
      name: 'Companion',
      id: 542882,
      appStoreLink: dictionary.companionAppStoreLink,
      googlePlayLink: dictionary.companionGooglePlayLink
    }];
    var selectedApp = apps.find(function (app) {
      return pimProduct.productId === app.id;
    });
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, selectedApp ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("a", {
      href: selectedApp.appStoreLink,
      title: "Download Oticon ".concat(selectedApp.name, " app from AppStore"),
      target: "_blank",
      rel: "noreferrer",
      className: "app-link",
      onClick: function onClick(e) {
        return trackMobileStoreLinks(e, selectedApp);
      }
    }, /*#__PURE__*/_react["default"].createElement("img", {
      height: "40",
      alt: "Download Oticon ".concat(selectedApp.name, " app from AppStore"),
      width: "135",
      src: dictionary.appStoreImg
    })), /*#__PURE__*/_react["default"].createElement("a", {
      href: selectedApp.googlePlayLink,
      target: "_blank",
      rel: "noreferrer",
      title: "Download Oticon ".concat(selectedApp.name, " app from Google Play"),
      className: "app-link",
      onClick: function onClick(e) {
        return trackMobileStoreLinks(e, selectedApp);
      }
    }, /*#__PURE__*/_react["default"].createElement("img", {
      height: "40",
      alt: "Download Oticon ".concat(selectedApp.name, " app from Google Play"),
      width: "135",
      src: dictionary.googlePlayImg
    }))) : /*#__PURE__*/_react["default"].createElement("a", {
      className: "pep-button bg-m-magenta custom-hover",
      tabIndex: 5,
      href: dictionary.buyPath
    }, dictionary.buyButton));
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactHelmet.Helmet, {
    script: [(0, _reactSchemaorg.helmetJsonLdProp)({
      '@context': 'https://schema.org',
      '@type': 'Product',
      brand: "".concat(pimProduct.productBrand),
      name: "".concat(pimProduct.title, " ").concat(pimProduct.subtitle),
      image: "".concat((pimProduct === null || pimProduct === void 0 ? void 0 : (_pimProduct$images$ = pimProduct.images[0]) === null || _pimProduct$images$ === void 0 ? void 0 : _pimProduct$images$.cdnUrl) || ''),
      description: "".concat(pimProduct.descriptionConsumer)
    })]
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "details"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-column headline-container"
  }, productName && /*#__PURE__*/_react["default"].createElement("h1", {
    dangerouslySetInnerHTML: {
      __html: productName
    }
  }), /*#__PURE__*/_react["default"].createElement("h2", null, pimProduct.subtitle)), isMobile && /*#__PURE__*/_react["default"].createElement(_ColorPickerComponent["default"], null), /*#__PURE__*/_react["default"].createElement("p", {
    className: "details__marketing-desc"
  }, (0, _convertEntities["default"])(pimProduct.descriptionConsumer)), pimProduct.productType === 'Hearing Instrument' && /*#__PURE__*/_react["default"].createElement(_SpecificDetailsComponent["default"], {
    pimProduct: pimProduct
  }), !isMobile && /*#__PURE__*/_react["default"].createElement(_ColorPickerComponent["default"], null), /*#__PURE__*/_react["default"].createElement("div", {
    className: "where-buy"
  }, renderProductLinks())));
};

var _default = DetailsDescriptionComponent;
exports["default"] = _default;